export default __webpack_public_path__ + "static/media/agent-illustration.67dad7ca.webp";